'use strict';
(() => {
 const hero=document.querySelector('.signals-hero');if(!hero)return;
 const slides=[...hero.querySelectorAll('.hero-slide')];
 const motion=matchMedia('(prefers-reduced-motion: reduce)');
 let index=0,timer,paused=motion.matches,hover=false,focused=false,inView=true,touch=null;
 function schedule(){clearTimeout(timer);if(!paused&&!hover&&!focused&&!document.hidden&&inView)timer=setTimeout(()=>show(index+1),5000)}
 function show(next,manual=false){
  index=(next+slides.length)%slides.length;
  slides.forEach((slide,i)=>{slide.classList.toggle('is-active',i===index);slide.setAttribute('aria-hidden',String(i!==index))});
  if(manual)hero.querySelector('.hero-announcement').textContent=slides[index].getAttribute('aria-label');
  schedule();
 }
 hero.querySelector('.hero-prev').addEventListener('click',()=>show(index-1,true));
 hero.querySelector('.hero-next').addEventListener('click',()=>show(index+1,true));
 hero.addEventListener('mouseenter',()=>{hover=true;schedule()});hero.addEventListener('mouseleave',()=>{hover=false;schedule()});
 hero.addEventListener('focusin',()=>{focused=true;schedule()});hero.addEventListener('focusout',e=>{if(!hero.contains(e.relatedTarget)){focused=false;schedule()}});
 hero.addEventListener('keydown',e=>{if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();show(index+(e.key==='ArrowRight'?1:-1),true)}});
 hero.addEventListener('touchstart',e=>{touch={x:e.touches[0].clientX,y:e.touches[0].clientY}},{passive:true});
 hero.addEventListener('touchend',e=>{if(!touch)return;const dx=e.changedTouches[0].clientX-touch.x,dy=e.changedTouches[0].clientY-touch.y;if(Math.abs(dx)>45&&Math.abs(dx)>Math.abs(dy)*1.3)show(index+(dx<0?1:-1),true);touch=null},{passive:true});
 hero.addEventListener('touchcancel',()=>{touch=null},{passive:true});
 document.addEventListener('visibilitychange',schedule);
 motion.addEventListener('change',()=>{paused=motion.matches;schedule()});
 new IntersectionObserver(entries=>{inView=entries[0].isIntersecting;schedule()},{threshold:.15}).observe(hero);
 schedule();
})();
